import { render } from "./ExchangePage.vue?vue&type=template&id=75721d59&scoped=true"
import script from "./ExchangePage.vue?vue&type=script&lang=js"
export * from "./ExchangePage.vue?vue&type=script&lang=js"

import "./ExchangePage.vue?vue&type=style&index=0&id=75721d59&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75721d59"]])

export default __exports__